module.exports = __webpack_public_path__ + "img/SL-M-160-220.852ef282.svg";